import React,{useState} from 'react';
import Navbar from '../layout/Navbar';
import Footer from '../footer/Footer';
import ApiContext from '../Context/ApiContext';
import SideDrawer from '../SideDrawer/SideDrawer';
const AboutUs = () => {
  const [sideDrawerStatus, setSideDrawer] = useState(false);
  return(
    <ApiContext.Provider value={{
      sideDrawerStatus,
       setSideDrawer: (() => setSideDrawer(!sideDrawerStatus))
    }}>
  <div>
    <div className="main contact wrap">
    <SideDrawer />
      <Navbar />
      <div className="container" style={{ padding: '2rem' }}>
        <h1 className="text-center">About Us</h1>
        <hr style={{ padding: '2rem' }} />
        <div className="text-white">
          <p className="p-text">
            At JustCoded Softskills Solutions, we teach you the latest software technology that drives today's business world. We give you access to choose from Frontend Stack, Backend Stack, Full Stack and Cloud Services.
          </p>
          <p className="p-text">
            To be a success in whatever you do, you must have a free mindset to learn and create anything you set forth to do. Your mind is so powerful that it can limit your abilities, but can also propel you to the utmost height. Free your mind today and start something with us.
            We build varieties of websites ranging from blogs, vblogs, corporate websites, e-commerce websites, e-learning websites etc. Do not just create a physical location for that your business, also create an online present with a powerful website that drives your sales and productivity.
          </p>
          <br />
          <h3 className="p-text">Why Softskills ?</h3>
          <br />
          <p className="p-text">
           Soft skills, also known as common skills or core skills, are skills which are desirable in all professions. These include critical thinking, problem solving, public speaking, professional writing, teamwork, digital literacy, leadership, professional attitude, work ethic, career management and intercultural fluency.

            Our core focus is <strong>Software development</strong> : which is the process of conceiving, specifying, designing, programming, documenting, testing, and bug fixing involved in creating and maintaining applications, frameworks, or other software components.
            
            Work with us today to take your career to the next level.
          </p>
        </div>
      </div>
    
    </div>
    <Footer />
  </div>
  </ApiContext.Provider>
)};

export default AboutUs;
